(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["micos-three-scene"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const smooth = (from, to, value) => {
      const x = clamp((value - from) / (to - from));
      return x * x * (3 - 2 * x);
    };
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const stage = root.querySelector('.micos-story__stage');
      const track = root.querySelector('.micos-story__track');
      const finalPanel = root.querySelector('[data-final]');
      const video = root.querySelector('[data-scroll-video]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      let scrollFrame = 0;
      let scrubFrame = 0;
      let timer = 0;
      let duration = 0;
      let targetTime = 0;
      let disposed = false;
      const scrub = () => {
        scrubFrame = 0;
        if (disposed || !duration || document.hidden) return;
        const difference = targetTime - video.currentTime;
        if (Math.abs(difference) <= 0.012) return;
        if (!video.seeking && video.readyState >= 2) {
          const step = Math.abs(difference) < 0.06 ? difference : difference * 0.42;
          video.currentTime = clamp(video.currentTime + step, 0, duration * 0.38);
        }
        scrubFrame = requestAnimationFrame(scrub);
      };
      const requestScrub = () => {
        if (!scrubFrame) scrubFrame = requestAnimationFrame(scrub);
      };
      const render = () => {
        scrollFrame = 0;
        if (disposed) return;
        const rect = track.getBoundingClientRect();
        const progress = clamp(-rect.top / Math.max(1, track.offsetHeight - stage.clientHeight));
        const reveal = smooth(0.9, 0.995, progress);
        root.style.setProperty('--hero-opacity', (1 - smooth(0.015, 0.13, progress)).toFixed(3));
        root.style.setProperty('--cue-opacity', (0.9 * (1 - smooth(0.01, 0.08, progress))).toFixed(3));
        root.style.setProperty('--surface-opacity', reveal.toFixed(3));
        root.style.setProperty('--final-opacity', reveal.toFixed(3));
        const interactive = reveal > 0.99;
        finalPanel.classList.toggle('is-active', interactive);
        finalPanel.inert = !interactive;
        finalPanel.setAttribute('aria-hidden', String(!interactive));
        if (duration) {
          targetTime = duration * 0.38 * smooth(0, 0.92, progress);
          requestScrub();
        }
      };
      const requestRender = () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(render);
      };
      window.addEventListener('scroll', requestRender, { passive: true, signal: controller.signal });
      window.addEventListener('resize', requestRender, options);
      const resizeObserver = new ResizeObserver(requestRender);
      resizeObserver.observe(stage);

      const selectVideoSource = () => {
        const source = mobileQuery.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (video.dataset.activeSrc === source) return;
        duration = 0;
        root.classList.remove('is-video-ready');
        video.dataset.activeSrc = source;
        video.src = source;
        video.load();
      };
      video.addEventListener('loadedmetadata', () => {
        duration = Number.isFinite(video.duration) ? video.duration : 0;
        requestRender();
      }, options);
      video.addEventListener('loadeddata', () => {
        root.classList.add('is-video-ready');
        requestRender();
      }, options);
      video.addEventListener('seeked', requestScrub, options);
      mobileQuery.addEventListener('change', selectVideoSource, options);

      const target = Date.parse(root.dataset.launchAt || '');
      const countdown = root.querySelector('[data-countdown]');
      const updateCountdown = () => {
        if (!Number.isFinite(target)) return;
        const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
        const values = {
          days: Math.floor(seconds / 86400),
          hours: Math.floor(seconds % 86400 / 3600),
          minutes: Math.floor(seconds % 3600 / 60),
          seconds: seconds % 60
        };
        Object.entries(values).forEach(([key, value]) => {
          countdown.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0');
        });
      };
      updateCountdown();
      if (Number.isFinite(target)) timer = window.setInterval(updateCountdown, 1000);
      selectVideoSource();
      requestRender();
      if (root.querySelector('.micos-story__message')) {
        requestAnimationFrame(() => {
          window.scrollTo({ top: window.scrollY + root.getBoundingClientRect().top + track.offsetHeight - stage.clientHeight, behavior: 'instant' });
          requestRender();
        });
      }
      const destroy = (event) => {
        if (event.target !== root && !event.target.contains(root)) return;
        disposed = true;
        controller.abort();
        resizeObserver.disconnect();
        cancelAnimationFrame(scrollFrame);
        cancelAnimationFrame(scrubFrame);
        window.clearInterval(timer);
        video.pause();
        document.removeEventListener('shopify:section:unload', destroy);
      };
      document.addEventListener('shopify:section:unload', destroy);
    };
    const initializeAll = () => document.querySelectorAll('[data-micos-story]').forEach(initialize);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
